import {
    BaseQueryApi,
    BaseQueryFn,
    FetchArgs,
    fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import {
    BaseQueryExtraOptions,
    QueryReturnValue,
} from '@reduxjs/toolkit/src/query/baseQueryTypes';
import { API_ENDPOINT_URL } from 'constant';
import { CustomError } from 'types/api-response/custom-error';
import { logOutStaffUser } from 'store/slices/staff-user/staff-user-slice';
import { Mutex } from 'async-mutex';
import { SignInResponse } from 'types/staff-user/staff-user';
/*import qs from 'qs';*/

const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
    baseUrl: API_ENDPOINT_URL,
    /* paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'brackets' }),*/
    prepareHeaders: (headers: Headers, {}) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        /*headers.set('XDEBUG_SESSION_START', `1`);
        headers.set('Access-Control-Allow-Origin', `*`);*/

        return headers;
    },
    timeout: 7000,
}) as BaseQueryFn<string | FetchArgs, unknown, CustomError>;

const baseQueryWithoutToken = fetchBaseQuery({
    baseUrl: API_ENDPOINT_URL,
    timeout: 7000,
}) as BaseQueryFn<string | FetchArgs, unknown, CustomError>;

export const baseQueryWithReauth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    CustomError
> = async (
    args: string | FetchArgs,
    api: BaseQueryApi,
    extraOptions: BaseQueryExtraOptions<BaseQueryFn>,
) => {
    await mutex.waitForUnlock();

    let result: QueryReturnValue<unknown, CustomError, object> =
        (await baseQuery(args, api, extraOptions)) as QueryReturnValue<
            unknown,
            CustomError,
            object
        >;

    if (result.error?.status === 401) {
        if (!mutex.isLocked()) {
            const release = await mutex.acquire();

            const token = localStorage.getItem('refresh_token');

            try {
                const refreshResult = (await baseQueryWithoutToken(
                    {
                        url: '/auth/refresh-token',
                        method: 'POST',
                        body: { refreshToken: token },
                    },
                    api,
                    extraOptions,
                )) as QueryReturnValue;

                if (refreshResult?.data) {
                    const refreshResultResponse: SignInResponse =
                        refreshResult?.data as SignInResponse;

                    localStorage.setItem(
                        'access_token',
                        refreshResultResponse.accessToken,
                    );
                    localStorage.setItem(
                        'refresh_token',
                        refreshResultResponse.refreshToken,
                    );

                    result = (await baseQuery(
                        args,
                        api,
                        extraOptions,
                    )) as QueryReturnValue<unknown, CustomError, object>;
                } else {
                    api.dispatch(logOutStaffUser());

                    localStorage.removeItem('staffUser');
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                }
            } finally {
                release();
            }
        } else {
            await mutex.waitForUnlock();

            result = (await baseQuery(
                args,
                api,
                extraOptions,
            )) as QueryReturnValue<unknown, CustomError, object>;
        }
    }
    return result;
};
